<template>
  <section class="relative mt-2">
    <div
      class="grid tablet:grid-cols-4 laptop-m:grid-cols-4 laptop-m:grid-cols-2 gap-10"
    >
      <div class="col-span-2" v-show="!crmOnly">
        <div class="text-xl laptop:text-2xl font-bold text-center mb-10">
          {{ webchat.header }}
        </div>
        <div class="mx-auto p-4 custom-shadow relative bg-white rounded-xl">
          <div class="flex">
            <div class="pack" :class="webchat.off ? '!w-[110px]' : ''">
              {{ webchat.label }}
            </div>
            <div v-if="webchat.off" class="off">
              <div>%{{ webchat.off }}</div>
              <div class="-mt-2">OFF</div>
            </div>
          </div>
          <div class="flex flex-col my-4 gap-3 min-h-[84px]">
            <div
              class="flex justify-start items-center text-sm"
              v-for="i in webchat.options"
              :key="webchat.title + i"
            >
              <div>
                <IconTik class="ml-1 w-2 fill-blue-700" />
              </div>
              <div>{{ i }}</div>
            </div>
          </div>
          <hr class="mb-2 bg-blue-500" />
          <div class="text-sm text-center">سالیانه</div>
          <div class="flex flex-col items-center">
            <div class="flex flex-col items-center">
              <span
                class="flex items-center justify-center my-3"
                :class="webchat.off ? 'line-through' : 'mt-12'"
              >
                <span :class="webchat.off ? '' : 'text-xl font-bold'">
                  {{ formatPrice(webchat.price) }}
                </span>
                <span>تومان</span>
              </span>
              <span
                v-if="webchat.off"
                class="flex items-center justify-center mb-3"
              >
                <span class="ml-1 text-xl font-bold">{{
                  getOffPrice(webchat.price, webchat.off)
                }}</span>
                <span>تومان</span>
              </span>
            </div>
            <BaseButton
              isLean
              size="2xl"
              :text="isWebChat ? 'حذف' : 'انتخاب'"
              @click="selectItem('Webchat')"
              :classes="isWebChat ? '!bg-blue-700' : ''"
            />
          </div>
        </div>
      </div>
      <div class="col-span-2" :class="crmOnly ? 'laptop:col-start-2' : ''">
        <div class="text-xl laptop:text-2xl font-bold text-center mb-10">
          {{ crm.header }}
        </div>
        <div class="mx-auto p-4 shadow-xl relative bg-white">
          <div class="flex">
            <div class="pack" :class="crm.off ? '!w-[110px]' : ''">
              {{ crm.label }}
            </div>
            <div v-if="crm.off" class="off">
              <div>%{{ crm.off }}</div>
              <div class="-mt-2">OFF</div>
            </div>
          </div>
          <div class="flex flex-col my-4 gap-3 min-h-[84px]">
            <div
              class="flex justify-start items-center text-sm"
              v-for="i in crm.options"
              :key="crm.title + i"
            >
              <div>
                <IconTik class="ml-1 w-2 fill-blue-700" />
              </div>
              <div>{{ i }}</div>
            </div>
          </div>
          <hr class="mb-2 bg-blue-500" />
          <div class="text-sm text-center">سالیانه</div>
          <div class="flex flex-col items-center">
            <div class="flex flex-col items-center">
              <span
                class="flex items-center justify-center my-3"
                :class="crm.off ? 'line-through' : 'mt-12'"
              >
                <span :class="crm.off ? '' : 'text-xl font-bold'">
                  {{ formatPrice(crm.price) }}
                </span>
                <span>تومان</span>
              </span>
              <span
                v-if="crm.off"
                class="flex items-center justify-center mb-3"
              >
                <span class="ml-1 text-xl font-bold">{{
                  getOffPrice(crm.price, crm.off)
                }}</span>
                <span>تومان</span>
              </span>
            </div>
            <BaseButton
              isLean
              size="2xl"
              :text="isCrm ? 'حذف' : 'انتخاب'"
              @click="selectItem('CRM')"
              :classes="isCrm ? '!bg-blue-700' : ''"
              :isDisabled="crm.isDisabled"
            />
          </div>
        </div>
        <div
          v-if="isCrm"
          class="text-red-500 text-xs text-start font-bold mt-6"
        >
          با خرید این امکان، به شما API برای اتصال به سرویس مرکز تلفن ابری داده
          می‌شود.
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  crmOnly: Boolean,
});

const { getAdditionalServices } = useOnlineShopping();

const emit = defineEmits(["goToNextStep", "goToPrevStep"]);
const bundleName = useState("BundleName");
const isCrm = useState("IsCrm") || false;
const isWebChat = useState("IsWebChat") || false;
const crmData = ref([]);
const SelectedCrmId = useState("SelectedCrmId") || null;

const selectItem = (title) => {
  if (title == "Webchat") {
    isWebChat.value = !isWebChat.value;
  } else if (title == "CRM") {
    isCrm.value = !isCrm.value;
    if (isCrm.value) {
      const selectedCrm = crmData.value.find(
        (item) => +item.price.replaceAll("/", "") == crm.value.price
      );
      SelectedCrmId.value = selectedCrm.id;
    }
  }
};

const webchat = ref({
  title: "Webchat",
  header: "سرویس وب چت",
  options: [
    "دریافت و پاسخگویی به پیام‌ها در اپلیکیشن",
    "شخصی‌سازی باکس گفتگو متناسب با تم سایت",
    "مناسب تمام سایت‌ها",
  ],
  label: "وب چت نواتل",
  price: null,
  off: null,
});
const crm = ref({
  title: "CRM",
  header: "افزونه CRM",
  options: [
    "راه‌اندازی و اتصال مرکز تلفن ابری نواتل به سی آر ام",
    "هزینه اتصال سی آر ام به مرکز تلفن نواتل شامل هزینه راه‌اندازی اولیه و تعداد کاربرین استفاده کننده از سی آر ام است.",
  ],
  label: "اتصال به CRM",
  price: "3900000",
  off: null,
  isDisabled: false,
});

onBeforeMount(async () => {
  let info = {
    Campaign: "",
    AdditionalServiceId: "",
  };
  const { data: additionalData, error: additionalError } =
    await getAdditionalServices({
      body: {
        ...info,
        type: "callcenter",
      },
    });
  if (additionalError.value || !additionalData.value) return;
  const data = toRaw(additionalData.value);
  const webchatData = data.find((item) => item.title == "Webchat");
  useState("WebchatId").value = webchatData.id;
  crmData.value = data.filter((item) => item.title == "CRM");

  webchat.value.price = +webchatData.price.replaceAll("/", "");
  webchat.value.off = webchatData.additionalServicesCampaigns.length
    ? webchatData.additionalServicesCampaigns[0].discount
    : null;

  updateCrmId(bundleName.value);
});

const { formatPrice } = useInputHelpers();
const getOffPrice = (price, off) => {
  const totalPrice = (price * off) / 100;
  const offPrice = formatPrice(price - totalPrice);
  return offPrice;
};

const updateCrmId = (bundleName) => {
  if (bundleName === "تلفن ثابت اینترنتی") {
    crm.value.isDisabled = true;
    return;
  }
  crm.value.isDisabled = false;

  crm.value.price =
    bundleName === "بسته برنزی"
      ? "3900000"
      : "5000000";

  if (isCrm.value) {
    const selectedCrm = crmData.value.find(
      (item) => +item.price.replaceAll("/", "") == crm.value.price
    );
    SelectedCrmId.value = selectedCrm.id;
  }
};

watch(
  () => bundleName.value,
  async (newVal) => {
    updateCrmId(newVal);
  }
);
</script>
